export default __webpack_public_path__ + "static/media/imgHCG-B.a9a035a9.png";